import Store from 'lib/Store/withLocalStorage';

import config from 'config/general';

import Header from 'components/molecule/HeaderLogged';

import { Container, Content } from './styles';

interface ITemplateProps {
  children: React.ReactNode;
}

const authStore = Store(`${config.localStorageKey}-auth`);

const Template: React.FC<ITemplateProps> = ({ children }) => {
  const isApp = authStore.getItem('isApp') === 'true';

  return (
    <>
      <Container className="template-default" isApp={isApp}>
        {!isApp && <Header />}

        <Content>{children}</Content>
      </Container>
    </>
  );
};
export default Template;
